<template>
  <a-locale-provider :locale="locale">
    <div class="order-search-container">
      <div class="order-search-tab">
        <a-tabs
          defaultActiveKey="1"
          v-model="activeTabKey"
        >
          <a-tab-pane tab="订单记录" key="1">
            <a-form class="order-search-form" :form="fullForm" :layout="formLayout">
              <a-row>
                <a-col :xs="24" :lg="fullTabLCol">
                  <a-form-item
                    label="订单号"
                  >
                    <a-input
                      v-decorator="[
                      'orderNo',
                          {
                          rules: [
                            { validator: handleFieldValidate }
                          ],
                          validateTrigger: 'blur'
                        }
                      ]"
                    ></a-input>
                  </a-form-item>
                </a-col>
                <!-- <a-col :xs="24" :lg="fullTabLCol">
                  <a-form-item
                    label="总订单号"
                  >
                    <a-input
                      v-decorator="[
                      'mergeOrderNo',
                          {
                          rules: [
                            { validator: handleFieldValidate }
                          ],
                          validateTrigger: 'blur'
                        }
                      ]"
                    ></a-input>
                  </a-form-item>
                </a-col> -->
                <a-col :xs="24" :lg="fullTabRCol">
                  <a-form-item
                    label="预定日期"
                  >
                    <a-date-picker
                      placeholder="选择日期"
                      v-model="orderStartDate"
                      :disabledDate="startDisabledDate"
                      :showToday="false"
                    />
                  </a-form-item>
                  <div class="form-split">至</div>
                  <a-form-item>
                    <a-date-picker
                      placeholder="选择日期"
                      v-model="orderEndDate"
                      :disabledDate="endDisabledDate"
                      :showToday="false"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <!-- <a-row>
              </a-row> -->
              <a-row>
                <!-- <a-col :xs="24" :lg="fullTabLCol" class="form-item-ticket">
                  <a-form-item
                    label="旅客姓名"
                  >
                    <a-input v-model="passengerName"></a-input>
                  </a-form-item>
                </a-col> -->
                <a-col :xs="24" :lg="fullTabLCol">
                  <a-form-item
                    label="订单状态"
                  >
                    <a-select v-model="orderStatus" defaultValue="">
                      <a-select-option value="">全部</a-select-option>
                      <a-select-option value="WP">等待付款</a-select-option>
                      <a-select-option value="PF">已付款</a-select-option>
                      <a-select-option value="XX">已取消</a-select-option>
                      <a-select-option value="RH">申退中</a-select-option>
                      <a-select-option value="RF">已退订</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xs="24" :lg="fullTabRCol">
                  <a-form-item
                    label="航段"
                  >
                    <l8-flightcityselector
                      v-model="depCity"
                      placeholder="出发城市"
                    ></l8-flightcityselector>
                  </a-form-item>
                  <div class="form-split">至</div>
                  <a-form-item>
                    <l8-flightcityselector
                      v-model="arrCity"
                      placeholder="到达城市"
                    ></l8-flightcityselector>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :xs="24" :lg="fullTabLCol">
                  <a-form-item
                    label="产品类型"
                  >
                    <a-select v-model="productType" defaultValue="">
                      <!-- <a-select-option value="">全部</a-select-option> -->
                      <a-select-option value="LUGGAGE">预付费行李</a-select-option>
                      <a-select-option value="MEAL">机上餐食</a-select-option>
                      <a-select-option value="ITINERARY">行程单</a-select-option>
                      <a-select-option value="VIPHALL">贵宾厅</a-select-option>
                      <a-select-option value="INSURANCE">保险</a-select-option>
                      <a-select-option value="SEAT">预选座位</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :xs="24" :lg="fullTabRCol">
                  <a-form-item
                    label="航班日期"
                  >
                    <a-date-picker
                      placeholder="选择日期"
                      v-model="segStartDate"
                      :disabledDate="startSegDisabledDate"
                      :showToday="false"
                    />
                  </a-form-item>
                  <div class="form-split">至</div>
                  <a-form-item>
                    <a-date-picker
                      placeholder="选择日期"
                      v-model="segEndDate"
                      :disabledDate="endSegDisabledDate"
                      :showToday="false"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :xs="24">
                  <a-form-item>
                    <a-button
                      class="order-primary-btn"
                      type="primary"
                      @click="fullFormSubmitHandler"
                    >
                      查询
                    </a-button>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div class="order-search-table">
        <a-table class="order-table"
          :dataSource='orderListData'
          :columns='orderListCols'
          :pagination="false"
        >
          <template slot="productName"  slot-scope="productName, record">
            <router-link v-if="record.orderNo" class="l8-href" :to="`/ancillary/v2/detail?orderNo=${record.orderNo}&seller=${record.seller}&sellerChannel=${record.source}${userType === 'CARRIER' ? '&outUserId=' +  record.outUserId : ''}`" target="_blank">{{ productName }}</router-link>
            <router-link v-else class="l8-href" :to="`/ancillary/v2/subDetail?subOrderNo=${record.subOrderNo}&seller=${record.seller}&sellerChannel=${record.source}&id=${record.serviceDetailId}${userType === 'CARRIER' ? '&outUserId=' +  record.outUserId : ''}`" target="_blank">{{ productName }}</router-link>
          </template>
        </a-table>
        <simple-pagination
          :current="page"
          :pageSize="pageSize"
          :total="total"
          @change="orderListChangeHandler"
        ></simple-pagination>
      </div>
      <div class="mod-tip" v-if="newAncillaryTips">
        <a-icon type="exclamation-circle" theme="filled" /> <span  style="display: inline-block;" v-html="newAncillaryTips"></span>
      </div>
    </div>
  </a-locale-provider>
</template>

<script>
import { queryAncillaryListNew } from '@/apis/ancillary'
import { aclSubOrderStatusMap, productTypeMap } from '@/dicts/ancillary'
import '@/components/l8-icon'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { validate } from '@/assets/js/validate'
import moment from 'moment'
import { map } from 'lodash'
import { userTypeMap } from '@/dicts/member'
import './index'

const mainSettings = window.__MICRO_ROOT__ ?? {}

const orderListCols = [
  {
    title: '序号',
    dataIndex: 'key',
    key: 'key'
  },
  {
    title: '旅客姓名',
    dataIndex: 'passengerName',
    key: 'passengerName'
  },
  {
    title: '产品类型',
    dataIndex: 'productType',
    key: 'productType'
  },
  {
    title: '产品名称',
    dataIndex: 'productName',
    key: 'productName',
    scopedSlots: { customRender: 'productName' }
  },
  {
    title: '航段',
    dataIndex: 'segments',
    key: 'segments'
  },
  {
    title: '航班日期',
    dataIndex: 'flightDate',
    key: 'flightDate'
  },
  {
    title: '预定日期',
    dataIndex: 'orderDate',
    key: 'orderDate'
  },
  {
    title: '票号',
    dataIndex: 'ticketNo',
    key: 'ticketNo'
  },
  {
    title: '消费码/快递单号',
    dataIndex: 'productCode',
    key: 'productCode'
  },
  {
    title: '订单状态',
    dataIndex: 'productStatus',
    key: 'productStatus'
  }
]

export default {
  data () {
    return {
      ifInternational: false,
      locale: zhCN,
      fullTabLCol: 9,
      fullTabRCol: 15,
      activeTabKey: '1',
      formLayout: 'inline',
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      fullForm: this.$form.createForm(this),
      orderListData: [],
      orderListCols: orderListCols,
      // 查询参数
      page: 1,
      pageSize: 10,
      orderStartDate: moment().subtract(1, 'months'),
      orderEndDate: moment(),
      // orderStartDate: null,
      // orderEndDate: null,
      segStartDate: null,
      segEndDate: null,
      depCity: '',
      arrCity: '',
      orderStatus: '',
      passengerName: '',
      orderNo: '',
      mergeOrderNo: '',
      productType: '',
      userType: '',
      newAncillaryTips: ''
    }
  },
  created () {
    const userInfo = mainSettings.user?.get()
    if (userInfo) {
      this.userType = userTypeMap[userInfo.userType]
    }

    let width = window.outerWidth
    if (width < 768) {
      this.formLayout = 'horizontal'
    }
    this.init()
    // this.fetchOrderList()
    this.getCmsData()
    window.__MICRO_ROOT__?.api?.track?.('managemybooking_neworder_ancillary')
  },
  watch: {
    $route: {
      handler () {
        this.init()
      },
      deep: true
    }
  },
  computed: {
    queryStartDate () {
      if (this.orderStartDate) {
        return this.orderStartDate.format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
    queryEndDate () {
      if (this.orderEndDate) {
        return this.orderEndDate.clone().add(1, 'd').format('YYYY-MM-DD') // 接口默认查的结束日期是0时的，前端协调处理
      } else {
        return ''
      }
    },
    queryParams () {
      let params = {
        'bookDateStart': this.queryStartDate,
        'bookDateEnd': this.queryEndDate,
        'page': this.page,
        'pageSize': this.pageSize,
        'depCode': this.depCity || '',
        'arrCode': this.arrCity || '',
        'flightDateEnd': this.segEndDate?.endOf('day') || '',
        'flightDateStart': this.segStartDate?.startOf('day') || '',
        'status': this.orderStatus || '',
        'orderNo': this.orderNo || '',
        'mergeOrderNo': this.mergeOrderNo || '',
        'passengerName': this.passengerName || '',
        'productType': this.productType || ''
      }

      return params
    }
  },
  methods: {
    init () {
      console.log('this.$route.fullPath >>>> ', this.$route.fullPath)
      if (this.$route.fullPath === '/ancillary/intlSearch') {
        this.ifInternational = true
      }
    },
    async getCmsData () {
      try {
        await window.__MICRO_ROOT__?.cms?.getPageData().then(res => {
          const { content } = res?.newAncillaryTips
          this.newAncillaryTips = content || ''
        })
      } catch (err) {}
    },
    startDisabledDate (current) {
      return current && current > moment().endOf('day')
    },
    endDisabledDate (current) {
      if (this.orderStartDate) {
        return current && (current < this.orderStartDate.startOf('day') || current > moment().endOf('day'))
      } else {
        return current && current > moment().endOf('day')
      }
    },
    startSegDisabledDate (current) {
      if (this.segEndDate) {
        return current && (current > this.segEndDate.endOf('day'))
      } else {
        return false
      }
    },
    endSegDisabledDate (current) {
      if (this.segStartDate) {
        return current && (current < this.segStartDate.startOf('day'))
      } else {
        return false
      }
    },
    handleFieldValidate (rule, value, callback) {
      const formValues = this.fullForm.getFieldsValue()
      validate('ordersearchNew', formValues, rule.fullField).then(({ valid, errors }) => {
        if (valid) {
          callback && callback()
        } else {
          callback(errors[0].message)
        }
      })
    },
    orderListChangeHandler (pagination) {
      this.page = pagination.current
      this.pageSize = pagination.pageSize

      this.fetchOrderList()
    },
    fullFormSubmitHandler () {
      this.fullForm.validateFieldsAndScroll((errors, values) => {
        if (!errors) {
          if (!this.productType) {
            this.$message.info('请先选择产品类型！')
            return
          }

          this.orderNo = values.orderNo
          this.mergeOrderNo = values.mergeOrderNo
          this.page = 1
          this.fetchOrderList()
        }
      })
    },
    async fetchOrderList () {
      try {
        const { ifInternational } = this
        const res = await queryAncillaryListNew({
          ...this.queryParams,
          isAll: true,
          ifInternational
        })

        this.updateOrderList(res.content)
        this.total = res.content.length < this.pageSize ? this.page : 0
      } catch (err) {
        this.$message.error(err.message || '订单查询失败，请稍后再试')
      }
    },
    updateOrderList (orderList) {
      let orderData = map(orderList, (order, index) => {
        if (order.productType === 'LUGGAGE') {
          order.productName = `预付费行李${order.productName}`
        }
        let item = {
          key: index + 1,
          orderNo: order.orderNo,
          subOrderNo: order.subOrderNo,
          serviceDetailId: order.serviceDetailId,
          passengerName: order.passengerName,
          productType: productTypeMap[order.productType],
          productName: order.productName,
          segments: order.depName + '-' + order.arrName,
          flightDate: moment(order.depTime).format('YYYY-MM-DD'),
          orderDate: moment(order.createTime).format('YYYY-MM-DD'),
          ticketNo: order.ticketNo || '--',
          productCode: order.serviceCode || '--',
          productStatus: aclSubOrderStatusMap[order.productStatus],
          outUserId: order.outUserId,
          seller: order.seller,
          source: order.source
        }

        return item
      })

      this.orderListData = orderData
    }
  }
}
</script>

<style lang="less" scoped>
  .order-search-container {
    padding: 20px;
    position: relative;
  }

  .ant-btn.order-primary-btn {
    width: 100px;
    height: 42px;
  }

  /*查询表单样式*/
  .order-search-form {

    &.ant-form-inline {
      .ant-form-item {
        &.ant-row {
          margin-bottom: 16px;
        }
      }

      .ant-form-item-label label {
        color: #333;
        width: 90px;
        display: inline-block;
      }
    }

    .input-ticket-prefix {
      width: 50px;
    }

    .input-ticket {
      width: 94px;
    }

    .ant-input {
      // height: 48px;
    }

    .ant-form-explain {
      margin-top: 0;
    }

    .form-item-ticket {
      .ant-form-explain {
        margin-right: -60px;
      }
    }

    .ant-select,
    .ant-cascader-picker {
      width: 182px;
      display: inline-block;
    }

    .ant-select-selection--single {
     height: 48px;
    }

    .ant-select-selection__rendered {
      line-height: 48px;
    }

    .form-split {
      display: inline-block;
      margin-right: 16px;
      line-height: 51.999px;
    }
  }

  /*订单列表*/
  .order-table .ant-table-thead > tr > th,
  .order-table .ant-table-tbody > tr > td {
    padding: 14px 5px;
  }

  .order-table {
    word-break: keep-all;
    white-space: nowrap;

    table {
      td {
        vertical-align: middle;
      }
    }

    .l8-href {
      text-decoration: underline;
    }
  }

  /*订单列表导出*/
  .order-ext {
    position: absolute;
    bottom: 30px;
    left: 20px;
    z-index: 1;
  }

  .order-ext-btn {
    display: inline-block;
    width: 32px;
    height: 32px;
    margin-left: 10px;
  }

  .mod-tip {
    padding: 0 10px;
    font-size: 12px;
    color: #888;

    span {
      margin-left: 5px;
    }
  }

  @media only screen and (max-width: 575px) {
    .order-search-form   {
      .ant-form-item {
        &.ant-row {
          margin-bottom: 6px;
        }
      }

      .input-ticket-prefix {
        width: 100%;
      }

      .input-ticket {
        width: 100%;
      }

      .ant-form-item-label {
        margin-bottom: 5px;
      }

      .ant-calendar-picker {
        width: 100%;
      }

      .ant-select,
      .ant-cascader-picker {
        width: 100%;
        display: inline-block;
      }

      .form-split {
        display: block;
        line-height: 30px;
      }
    }

    .order-table {
      table {
        td {
          vertical-align: middle;
          min-width: 120px;
        }
      }

      .ant-table {
        overflow-x: scroll;
        word-break: keep-all;
      }
    }

    .ant-btn.order-primary-btn {
      width: 100%;
    }
  }
</style>
